var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "formsContainer" },
    [
      _vm.objectLayer
        ? _c(_vm.openedFormComponent(_vm.objectLayer), {
            key: _vm.updated,
            tag: "component",
            staticStyle: { "z-index": "150" },
            attrs: {
              "object-data": _vm.selectedObjectData,
              "object-layer": _vm.objectLayer
            },
            on: {
              close: function($event) {
                return _vm.closeForm()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b473f298", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b473f298","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Network/Forms/ObjectForm.vue
// module id = null
// module chunks = 